
/* injects from baggage-loader */
require('./culture-select.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('cultureSelect', {
    templateUrl: '/app/components/deal-sheet/culture-select.component.html',
    controller: CultureSelectController,
    bindings: {
        countryId: '<',
        dealerSettings: '<',
        customScripts: '<',
        onSelect: '&'
    }
});

/* @ngInject */
function CultureSelectController($translate, $timeout, userService, dealerCountries, cultures) {
    const $ctrl = this;

    $ctrl.cultures = cultures;
    $ctrl.dealerCountries = dealerCountries;
    $ctrl.cultureOptions = [];
    $ctrl.changeCulture = changeCulture;
    $ctrl.getCultureLabelKey = getCultureLabelKey;
    $ctrl.$onInit = init;
    $ctrl.$onChanges = onChanges;

    function init() {
        $ctrl.selectedCulture = userService.getCultureNameSync();
        refreshCultureOptions(true);
    }

    function onChanges(changes) {
        if ((changes.countryId && changes.countryId.currentValue)
            || (changes.dealerSettings && changes.dealerSettings.currentValue)
            || (changes.customScripts && changes.customScripts.currentValue)) {
            refreshCultureOptions();
        }
    }

    function changeCulture(culture) {
        if ($translate.getTranslationTable(culture)) {
            $ctrl.selectedCulture = culture;
            $ctrl.onSelect({ culture: $ctrl.selectedCulture });
        }
        else {
            $ctrl.selectedCulture = culture;

            $timeout(function () {
                $ctrl.selectedCulture = null;
            }, 100);

            $timeout(function () {
                $ctrl.selectedCulture = culture;
                $ctrl.onSelect({ culture: $ctrl.selectedCulture });
            }, 100);
        }
    }

    function refreshCultureOptions(forceNotify) {
        const scriptCultures = collectScriptCultures();
        const normalizedMap = scriptCultures.reduce(function (acc, culture) {
            acc[normalizeCulture(culture)] = culture;
            return acc;
        }, {});
        let options = [];

        if (normalizedMap['en-us'] && normalizedMap['es-us']) {
            options = [normalizedMap['en-us'], normalizedMap['es-us']];
        } else if (normalizedMap['en-us'] && normalizedMap['fr-ca']) {
            options = [normalizedMap['en-us'], normalizedMap['fr-ca']];
        } else if (normalizedMap['en-ca'] && normalizedMap['fr-ca']) {
            options = [normalizedMap['en-ca'], normalizedMap['fr-ca']];
        } else if (scriptCultures.length) {
            options = scriptCultures.slice(0, 2);
        } else {
            const defaultCulture = resolveDefaultCulture();
            const secondaryCulture = resolveSecondaryCulture();

            if (defaultCulture) {
                options.push(defaultCulture);
            }

            if (secondaryCulture
                && normalizeCulture(secondaryCulture) !== normalizeCulture(defaultCulture)
                && !isSameLanguage(secondaryCulture, defaultCulture)
                && isSupportedCulture(secondaryCulture)) {
                options.push(secondaryCulture);
            } else if (shouldMergeScriptCultures()) {
                options = mergeScriptCultures(options, defaultCulture);
            }
        }

        $ctrl.cultureOptions = options;

        if (!options.length) {
            return;
        }

        const selected = normalizeCulture($ctrl.selectedCulture);
        const isSelectedValid = options.some(function (option) {
            return normalizeCulture(option) === selected;
        });

        if (!isSelectedValid) {
            $ctrl.selectedCulture = options[0];
            if ($ctrl.onSelect) {
                $ctrl.onSelect({ culture: $ctrl.selectedCulture });
            }
        } else if (forceNotify && $ctrl.onSelect) {
            $ctrl.onSelect({ culture: $ctrl.selectedCulture });
        }
    }

    function resolveDefaultCulture() {
        if ($ctrl.dealerSettings && $ctrl.dealerSettings.defaultCultureName) {
            if (isSupportedCulture($ctrl.dealerSettings.defaultCultureName)) {
                return $ctrl.dealerSettings.defaultCultureName;
            }
        }

        return ($ctrl.countryId == $ctrl.dealerCountries.canada)
            ? $ctrl.cultures.enCA
            : $ctrl.cultures.enUS;
    }

    function resolveSecondaryCulture() {
        if ($ctrl.dealerSettings && $ctrl.dealerSettings.secondaryCultureName) {
            return $ctrl.dealerSettings.secondaryCultureName;
        }
        return null;
    }

    function shouldMergeScriptCultures() {
        if ($ctrl.dealerSettings && $ctrl.dealerSettings.defaultCultureName) {
            return isSupportedCulture($ctrl.dealerSettings.defaultCultureName);
        }
        return true;
    }

    function mergeScriptCultures(options, defaultCulture) {
        const merged = options.slice();
        const scriptCultures = collectScriptCultures();
        const defaultLanguage = getLanguageCode(defaultCulture);

        scriptCultures.forEach(function (culture) {
            if (defaultLanguage && getLanguageCode(culture) === defaultLanguage) {
                return;
            }
            const exists = merged.some(function (existing) {
                return normalizeCulture(existing) === normalizeCulture(culture);
            });
            if (!exists) {
                merged.push(culture);
            }
        });

        return merged;
    }

    function collectScriptCultures() {
        if (!$ctrl.customScripts || !$ctrl.customScripts.length) {
            return [];
        }

        const culturesFound = {};
        const ordered = [];
        $ctrl.customScripts.forEach(function (script) {
            const culture = normalizeCulture(script.culture);
            if (culture && !culturesFound[culture]) {
                culturesFound[culture] = script.culture;
                ordered.push(script.culture);
            }
        });

        return ordered;
    }

    function normalizeCulture(culture) {
        return (culture || '').toLowerCase().replace('_', '-');
    }

    function isSupportedCulture(culture) {
        const normalized = normalizeCulture(culture);
        return normalized === 'en-us' || normalized === 'en-ca' || normalized === 'fr-ca' || normalized === 'es-us';
    }

    function getLanguageCode(culture) {
        const normalized = normalizeCulture(culture);
        return normalized ? normalized.split('-')[0] : '';
    }

    function isSameLanguage(firstCulture, secondCulture) {
        const first = getLanguageCode(firstCulture);
        const second = getLanguageCode(secondCulture);
        return first && second && first === second;
    }

    function getCultureLabelKey(culture) {
        const normalized = normalizeCulture(culture);
        if (normalized.indexOf('fr-') === 0) {
            return 'french';
        }
        if (normalized.indexOf('es-') === 0) {
            return 'spanish';
        }
        return 'english';
    }
}
